import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'antd';
import { RightOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAuth } from '../../auth/AuthContext';
import { formatCredits } from '../../data/home';
import ActivityList from '../Home/components/ActivityList';
import TopUpModal from '../Home/components/TopUpModal';
import WalletCard from '../Home/components/WalletCard';
import { readWalletAmounts } from './walletData';
import '../Home/Home.css';
import './Wallet.css';

function WalletPage() {
    const { t } = useTranslation('wallet');
    const { user, refreshProfile } = useAuth();
    const [hideBalance, setHideBalance] = useState(false);
    const [topUpOpen, setTopUpOpen] = useState(false);
    const [reservedInfoOpen, setReservedInfoOpen] = useState(false);
    const wallet = readWalletAmounts(user);

    useEffect(() => {
        void refreshProfile();
    }, [refreshProfile]);

    return (
        <div className="wallet-page">
            <div className="page-heading">
                <div>
                    <h1>{t('heading.title')}</h1>
                    <p>{t('heading.subtitle')}</p>
                </div>
                <span className="wallet-page__badge">{t('heading.rate')}</span>
            </div>

            <div className="wallet-page__cols">
                <div>
                    <WalletCard
                        availableCredits={wallet.availableCredits}
                        reservedCredits={wallet.reservedCredits}
                        hideBalance={hideBalance}
                        onToggleBalance={() => setHideBalance((value) => !value)}
                        onTopUp={() => setTopUpOpen(true)}
                    />

                    <div className="wallet-summary">
                        <div className="wallet-stat">
                            <small>{t('summary.reserved')}</small>
                            <strong>
                                {hideBalance ? '••' : formatCredits(wallet.reservedCredits)}{' '}
                                <small>{t('summary.credits', { count: wallet.reservedCredits })}</small>
                            </strong>
                        </div>
                        <div className="wallet-stat">
                            <small>{t('summary.pending')}</small>
                            <strong>
                                {hideBalance ? '••' : formatCredits(wallet.pendingUsdt)}{' '}
                                <small>USDT</small>
                            </strong>
                        </div>
                    </div>
                </div>

                <section className="panel">
                    <div className="section-head">
                        <h2>{t('guide.title')}</h2>
                        <SafetyCertificateOutlined className="wallet-page__shield" />
                    </div>

                    <div className="wallet-step">
                        <span className="wallet-step__number">1</span>
                        <div>
                            <strong>{t('guide.add.title')}</strong>
                            <p>{t('guide.add.description')}</p>
                        </div>
                    </div>
                    <div className="wallet-step">
                        <span className="wallet-step__number">2</span>
                        <div>
                            <strong>{t('guide.receive.title')}</strong>
                            <p>{t('guide.receive.description')}</p>
                        </div>
                    </div>
                    <div className="wallet-step">
                        <span className="wallet-step__number">3</span>
                        <div>
                            <strong>{t('guide.spend.title')}</strong>
                            <p>{t('guide.spend.description')}</p>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="text-button"
                        onClick={() => setReservedInfoOpen(true)}
                    >
                        {t('reservedInfo.link')}
                        <RightOutlined />
                    </button>
                </section>
            </div>

            <ActivityList title={t('activityTitle')} className="section panel" limit={10} />

            <TopUpModal open={topUpOpen} onClose={() => setTopUpOpen(false)} />

            <Modal
                open={reservedInfoOpen}
                onCancel={() => setReservedInfoOpen(false)}
                footer={
                    <Button type="primary" onClick={() => setReservedInfoOpen(false)}>
                        {t('reservedInfo.gotIt')}
                    </Button>
                }
                title={t('reservedInfo.title')}
                centered
                className="topup-modal"
            >
                <div className="wallet-page__notice">
                    {t('reservedInfo.notice')}
                </div>
                <p className="wallet-page__hint">
                    {t('reservedInfo.hint')}
                </p>
            </Modal>
        </div>
    );
}

export default WalletPage;
